import {gsap} from "gsap";

$(document).on('click', '.sec-3-btn--usecoupon', (e) => {
    e.preventDefault();
    promokit.coupon();
});

$(document).on('click', '.sec-3-btn--check', (e) => {
    e.preventDefault();
    $('.sec-3-btn__tooltip').toggle();
});

const animation = gsap.timeline({paused: true})
    .addLabel('start')
    .from('#section-3 .sec-common__title', {opacity: 0, duration: .8}, 'start+=0.1')
    .from('#section-3 .sec-common__subtitle', {opacity: 0, duration: .8}, 'start+=0.1')
    .from('#section-3 .sec-common__period', {opacity: 0, duration: .8}, 'start+=0.1')
    .from('#section-3 .sec-3__server', {opacity: 0, y: 20,  duration: .6}, 'start+=0.4')
    .from('#section-3 .sec-3__character', {opacity: 0, y: 20, duration: .6}, 'start+=0.4')

export default {
    id: '#section-3',
    name: '사전 캐릭터 생성',
    enterEnd() {
        animation.play();
    },
    leaveEnd() {
        animation.seek(0).pause();
    }
};



// WEBPACK FOOTER //
// ./src/js/section-3.js